import { Dispatch } from 'react';
import { request } from "./request";
import { SessionAction } from '../interfaces/Session';

export function getThicket(dispatch: Dispatch<SessionAction>) {
  return request(dispatch, '/thicket', {
    method: 'GET',
  });
}